import { ComponentPropsWithRef, ComponentType, createElement } from 'react';
import { renderToString } from 'react-dom/server';

/**
 * Converts an SVG string to a data URL.
 *
 * @param svg - The SVG string to convert.
 * @returns The data URL.
 */
export const svgToDataUri = (svg: string) =>
  `data:image/svg+xml,${encodeURIComponent(svg)}`;

/**
 * Converts a React SVG component (e.g. an icon) to a data URL.
 *
 * @param Component - The React SVG component to convert.
 * @param props - The props to pass to the component.
 * @returns The data URL.
 *
 * @example
 * ```tsx
 * import { IconCheck } from '@tabler/icons-react';
 * const IconCheckDataUrl = svgComponentToMarkupString(IconCheck, { color: 'red' });
 *
 * <div style={{ backgroundImage: `url(${IconCheckDataUrl})` }} />
 * ```
 */
export const svgComponentToMarkupString = <T extends ComponentType<any>>(
  Component: T,
  props: ComponentPropsWithRef<T>,
) => svgToDataUri(renderToString(createElement(Component, props)));
